import { useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** The counts behind the list's health tiles. */
export function useProductHealth(enabled: boolean) {
  return useQuery({
    queryKey: productKeys.health(),
    queryFn: () => productsApi.health(),
    enabled,
  });
}
